import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiActions, visualizerActions } from "../../store";

import PopUpModal from "../PopUpModal/PopUpModal";

import styles from "./ZoomModal.module.css";

export default function ZoomModal() {
    const dispatch = useDispatch();
    const [src, setSrc] = useState(null);
   
    const handleClose = () => {
        dispatch(uiActions.setZoomModalActive(false));
    };

    useEffect(() => {
        const mainImg = document.getElementById("chamViz");
        if (!mainImg) return;

        setSrc(document.querySelector('#chamViz img').getAttribute('src'))
    }, []);

    return (

        <PopUpModal handleClose={handleClose}>
            <div className={styles.contentMain}>
                {src ? (
                    <img src={src} alt="Zoomed preview"  />
                ) : (
                    <div className={styles.placeholder}>Loading preview…</div>
                )}
            </div>
        </PopUpModal>
       
    );
}
